import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(filter);

export function filter(iterator, test) {
  var result, index;
  return _regeneratorRuntime.wrap(function filter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          index = -1;

        case 1:
          if ((result = iterator.next()).done) {
            _context.next = 7;
            break;
          }

          if (!test(result.value, ++index)) {
            _context.next = 5;
            break;
          }

          _context.next = 5;
          return result.value;

        case 5:
          _context.next = 1;
          break;

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}